<form [formGroup]="trialForm" (ngSubmit)="submitForm()" class="trial-form" autocomplete="on">
    <!-- <mat-form-field>
        <mat-label>Your Name</mat-label>
        <input matInput type="text" name="name" autocomplete="name" formControlName="name" />
    </mat-form-field> -->
    
    <mat-form-field>
        <mat-label id="label-company-name">Company Name</mat-label>
        <input matInput type="text" name="company" formControlName="company" id="new-tenant-trial-company-input" aria-labelledby="label-company-name" />
        @if (tenantSlugAlreadyExists()) {
            <mat-error>
                Tenant name already exists
            </mat-error>
        }
    </mat-form-field>
    
    <!-- <mat-form-field>
        <mat-label>Phone Number</mat-label>
        <input matInput type="tel" name="phone" autocomplete="tel" placeholder="+0 000 000 0000" formControlName="phone" />
    </mat-form-field> -->
    
    <!-- <mat-form-field>
        <mat-label>Work Email</mat-label>
        <input matInput type="email" name="email" autocomplete="email" formControlName="email" />
    </mat-form-field> -->
    
    <mat-form-field>
        <mat-label id="label-trial-tenant-industry">Tenant Industry</mat-label>
        <mat-select class="mat-primary" formControlName="tenantIndustry" name="tenantIndustry" id="new-tenant-trial-industry-select" aria-labelledby="label-trial-tenant-industry">
            @for (type of tenantIndustryTypes; track type) {
                <mat-option [value]="type">
                    {{ type }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    
    <mat-form-field>
        <mat-label id="label-trial-company-size">Company Size</mat-label>
        <mat-select formControlName="companySize" name="companySize" id="new-tenant-trial-company-size-select" aria-labelledby="label-trial-company-size">
            @for (size of tenantSizes; track size) {
                <mat-option [value]="size">
                    {{ size }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    
    <mat-form-field>
        <mat-label id="label-trial-tenant-group">Tenant Group</mat-label>
        <mat-select formControlName="tenantGroup" name="tenantGroup" id="new-tenant-trial-group-select" aria-labelledby="label-trial-tenant-group">
            @for (permissionGroup of tenantPermissionGroups; track permissionGroup.name) {
                <mat-option [value]="permissionGroup.name">
                    {{ permissionGroup.displayName }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    
    <mat-form-field>
        <mat-label id="label-trial-best-practice">Create From Tenant</mat-label>
        <mat-select name="createFromTenant" formControlName="bestPracticeTenant" id="new-tenant-trial-best-practice-select" aria-labelledby="label-trial-best-practice">
            @for (tenant of bestPracticeTenants; track tenant.Value) {
                <mat-option [value]="tenant.Value">
                  {{ tenant.Text }}
                </mat-option>
            }
          </mat-select>
    </mat-form-field>

    <div class="button-container">
        <button mat-raised-button [disabled]="!isSubmitButtonAvailable()" class="mat-accent submit-button" type="submit">Start Trial</button>
    </div>
</form>